import { Pipe, PipeTransform } from '@angular/core';
import { EventData } from '../../providers/event';

@Pipe({
  name: 'sub_event'
})
export class SubEventPipe implements PipeTransform {

  constructor(
    private eventData: EventData
  ) {}

  transform(idEvent: string, idClient: string) {
    return this.eventData.getEventsSubEvent(idClient, idEvent);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/event/sub-event.ts